
import {colors} from '@xpertdox_js/xdstyle';

export default {
  title: {
    color: '#fff',
    padding: '10px 2px',
    textAlign: 'center',
    fontSize: '1.8rem',
    background: colors.xdDarkBlue,
    margin: 0,
    borderTopRightRadius: '4px',
    borderTopLeftRadius: '4px'
  },
  content: {
    padding: '8px'
  },
  exampleText: {
    fontSize: '1.4rem'
  },
  instructionList: {
    paddingLeft: '18px'
  },
  downloadLink: {
    color: colors.xdHighlight,
  },
  uploadList: {
    container: {
      backgroundColor: 'rgb(199, 199, 199,.05)',
      boxShadow: 'inset 0 0 2px #d3d3d3',
      position: 'fixed',
      top: '0',
      overflowX: 'scroll',
      right: '0',
      border:'solid .05px rgba(0, 0, 0, .065)',
      width: '300px',
      height: '100%',
      padding: '55px 8px 8px 8px',
      display: 'flex',
      flexDirection: 'column'
    },
    itemText: {
      margin: 0,
      marginBottom: 2
    },
    actions: {
      marginTop: 8
    },
    icon: {
      height: 17,
      fill: colors.xdHighlight,
      cursor: 'pointer',
      float: 'right'
    },
    listItem: {
      backgroundColor: 'white',
      border: 'solid .05px rgba(0, 0, 0, .065)',
      fontSize: '13px',
      padding: '5px',
      boxSizing: 'border-box',
      marginBottom: '10px'
    }
  }
}
